<template>
  <span :class="['tag', 'is-rounded', STATE_COLORS[state] ?? '']">
    {{ startCase(state) }}
    <button v-if="removable" class="delete is-small" type="button" @click="emit('remove')" />
  </span>
</template>

<script setup>
  import { startCase } from "lodash-es";

  const STATE_COLORS = {
    draft: "",
    shipped: "is-success",
    cancelled: "is-danger",
    active: "is-info",
  };

  defineProps({
    state: { type: String, required: true },
    removable: { type: Boolean, default: false },
  });

  const emit = defineEmits(["remove"]);
</script>
